import Block from '../block'

export default class BlockImage extends Block {
	static title = 'block-image'

	// the shape half of the block-image--<shape>-<caption position> modifier
	static shapes = ['square', 'portrait', 'landscape', 'circle']

	constructor($el) {
		super($el)

		this.images = this.$el.findElement('item')

		if (!this.hasCaptionInside()) {
			return
		}

		if (this.$el.hasModifier('popup')) {
			this.initPopup()
		}

		if (this.$el.hasModifier('slidein')) {
			this.initSlidein()
		}
	}

	hasCaptionInside() {
		return BlockImage.shapes.some((shape) =>
			this.$el.hasModifier(`${shape}-inside`),
		)
	}

	findIn(image, element) {
		return image.find(`.${BlockImage.title}__${element}`)
	}

	initPopup() {
		this.images.each((index, image) => {
			const item = $(image)
			const button = this.findIn(item, 'toggle')
			const content = this.findIn(item, 'content')
			const scrollContainer = this.findIn(item, 'scroll')
			const imageText = this.findIn(item, 'text')
			const scrollHint = this.findIn(item, 'scroll-hint')

			if (button.length > 0) {
				button.on('click', (event) => {
					event.preventDefault()
					event.stopPropagation()

					content.toggleClass('hidden')
					button.attr(
						'aria-expanded',
						content.hasClass('hidden') ? 'false' : 'true',
					)
					// toggle hidden class for both the plus and minus icon
					// because the minus has the hidden class on load and the plus icon does not, only one of the two should be visible at all times
					button.find('i').toggleClass('hidden')
				})
			}

			if (scrollHint.length > 0) {
				if (imageText.outerHeight() > scrollContainer.height()) {
					scrollHint.removeModifier('hidden')
				}

				scrollContainer.on('scroll', () => {
					scrollHint.addModifier('hidden')

					if (scrollContainer.scrollTop() == 0) {
						scrollHint.removeModifier('hidden')
					}
				})
			}
		})
	}

	initSlidein() {
		this.images.each((index, image) => {
			const item = $(image)

			if (this.findIn(item, 'toggle').length === 0) {
				return
			}

			const bind = () => {
				item.off('.slidein')

				if (this.isSmallScreen()) {
					item.on('click.slidein', () => {
						this.setSlideinActive(item, !this.isSlideinActive(item))
					})

					return
				}

				item.on('pointerenter.slidein', () => {
					this.setSlideinActive(item, true)
				})

				item.on('pointerleave.slidein', () => {
					this.setSlideinActive(item, false)
				})
			}

			bind()

			$(window).on('resize', bind)

			// keyboard: the toggle button opens it, a linked image opens while its link has focus
			this.findIn(item, 'toggle')
				.filter('button')
				.on('click', (event) => {
					// a desktop pointer already opened it on hover; detail is 0 for Enter and Space
					if (event.detail > 0 && !this.isSmallScreen()) {
						return
					}

					event.stopPropagation()
					this.setSlideinActive(item, !this.isSlideinActive(item))
				})

			if (item.is('a')) {
				item.on('focusin', () => {
					if (item.is(':focus-visible')) {
						this.setSlideinActive(item, true)
					}
				})
				item.on('focusout', () => this.setSlideinActive(item, false))
			}
		})
	}

	isSlideinActive(image) {
		return this.findIn(image, 'content').hasModifier('active')
	}

	setSlideinActive(image, active) {
		if (this.isSlideinActive(image) === active) {
			return
		}

		const content = this.findIn(image, 'content')

		if (active) {
			content.addModifier('active')
		} else {
			content.removeModifier('active')
		}

		this.findIn(image, 'text').toggleClass('hidden', !active)
		// toggle hidden class for both the plus and minus icon
		// because the minus has the hidden class on load and the plus icon does not, only one of the two should be visible at all times
		this.findIn(image, 'toggle').find('i').toggleClass('hidden')
		this.findIn(image, 'toggle')
			.filter('button')
			.attr('aria-expanded', active ? 'true' : 'false')
	}

	isSmallScreen() {
		return $(window).width() <= 1023
	}
}
